import {
	Component,
	Input,
	Output,
	EventEmitter,
	OnDestroy,
	OnChanges,
	SimpleChanges,
	ChangeDetectorRef,
} from '@angular/core'
import { CommonModule } from '@angular/common'
import { SecureFileService } from 'src/app/core/services/secure-file.service'
import { Subscription, of } from 'rxjs'
import { catchError } from 'rxjs/operators'

@Component({
	selector: 'app-secure-image',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './secure-image.component.html',
	styleUrls: ['./secure-image.component.scss'],
})
export class SecureImageComponent implements OnDestroy, OnChanges {
	@Input() filePath?: string | null
	@Input() reloadKey?: string | number | null
	@Input() alt = 'Imagen'
	@Input() className = ''

	@Output() imageLoaded = new EventEmitter<void>()
	@Output() imageError = new EventEmitter<Error | Event>()
	@Output() imageRequestUrl = new EventEmitter<string>()

	imageSrc?: string | null
	loading = false
	lastRequestUrl: string | null = null
	lastError: any = null
	private sub?: Subscription

	constructor(
		private readonly secureFile: SecureFileService,
		private readonly cdr: ChangeDetectorRef
	) {}

	ngOnDestroy(): void {
		this.revoke()
		this.sub?.unsubscribe()
	}

	ngOnChanges(changes: SimpleChanges) {
		const filePathChange = changes['filePath']
		const reloadKeyChange = changes['reloadKey']
		const filePathChanged =
			!!filePathChange && filePathChange.previousValue !== filePathChange.currentValue
		const reloadKeyChanged =
			!!reloadKeyChange && reloadKeyChange.previousValue !== reloadKeyChange.currentValue

		if (filePathChanged || reloadKeyChanged) {
			this.lastError = null
			this.lastRequestUrl = null
			this.loadImage()
		}
	}

	private revoke() {
		if (this.imageSrc && this.imageSrc.startsWith('blob:')) {
			URL.revokeObjectURL(this.imageSrc)
		}
	}

	private loadImage() {
		this.revoke()
		this.sub?.unsubscribe()
		this.imageSrc = null
		const path = this.filePath
		if (!path) return

		this.loading = true
		const viewUrl: string | null = this.secureFile.getViewUrl(path)
		this.imageRequestUrl.emit(viewUrl)
		this.lastRequestUrl = viewUrl

		this.sub = this.secureFile
			.getSecureImageWithToken(path)
			.pipe(
				catchError((err) => {
					this.loading = false
					this.lastError = err
					this.imageError.emit(err)
					return of(null)
				})
			)
			.subscribe({
				next: (objUrl) => {
					this.loading = false
					if (objUrl) {
						this.imageSrc = objUrl
						this.imageLoaded.emit()
						try {
							this.cdr.detectChanges()
						} catch (e) {}
					}
				},
				error: (err) => {
					this.loading = false
					this.lastError = err
					this.imageError.emit(err)
				},
				complete: () => {
					this.loading = false
					this.lastRequestUrl = null
					this.lastError = null
				},
			})
	}

	onNativeLoad(): void {
		this.imageLoaded.emit()
	}

	onNativeError(ev: Event): void {
		this.imageError.emit(ev)
	}
}
